module.exports = __webpack_public_path__ + "assets/img/dayu_online_doctor_large.ac64644b.png";